import { render, staticRenderFns } from "./NewsletterSwitch.vue?vue&type=template&id=02212ae6&"
import script from "./NewsletterSwitch.vue?vue&type=script&lang=js&"
export * from "./NewsletterSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports